import Owner from '~models/owner'
import AppDataRepository from '~repositories/impl/app-data-repository'
import { setLoading } from '~store/loading'

import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query'

import { APP_QUERY_KEYS } from './query-keys'

const useUpdateMyProfile = (
  options?: UseMutationOptions<
    Owner.Level2,
    Error,
    Partial<Pick<Owner.ILevel2, 'nickname' | 'thumbnail_uri' | 'phone_number'>> & {
      token?: string
      code?: string
    }
  >
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: AppDataRepository.updateMyProfile,
    onMutate: req => {
      options?.onMutate?.(req)
      setLoading(true)
    },
    onSuccess: (res, req, ctx) => {
      options?.onSuccess?.(res, req, ctx)
      queryClient.setQueryData(APP_QUERY_KEYS.myProfile, res)
    },
    onSettled: (res, err, req, ctx) => {
      options?.onSettled?.(res, err, req, ctx)
      setLoading(false)
    },
  })
}

export default useUpdateMyProfile
